import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Form, Button, FloatingLabel } from 'react-bootstrap';
import '../../Assets/Styles/customFonts.css';
import '../../Components/_Authentication/LoginPage.css';
import logo from '../../Assets/Images/NEXI_RGB.jpg';
import UserService from '../../Services/UserService';
import Cookies from 'universal-cookie';
import login from '../../Components/_Authentication/Login';
import {REDIRECT_URL_PROJECT,REDIRECT_URL_CHPWD,REDIRECT_URL,TOKEN_URL,CLIENT_ID} from '../../Config/AppConfiguration';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const TokenPage = () => {
  console.log("App loaded at:", window.location.href);
 
    const cookies = new Cookies();
 
  const cookieNameUser = "userId";
  const cookieNameToken = "accessToken";
  const cookieNameCurrentUser = "currentAPIMUser";
  const [dataLoaded, setDataLoaded] = useState(false);
 
  const location = useLocation();
  const navigate = useNavigate();
  const [userCookieAvailable, setUserCookieAvailable] = useState(false);
 const [redirectURL, setRedirectURL] = useState(REDIRECT_URL_PROJECT);
  // 2. PKCE/OAuth2 flow: Generate and store PKCE and state ONCE, reuse for all authorize/token calls
  useEffect(() => {
    // Auth flow
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    callGetAccessTokenApi(code,state);
    // eslint-disable-next-line
  }, [location.search]);
 
  // 3. Exchange code for token when redirected back with code
  const callGetAccessTokenApi = (code,state) => {
 
    console.log("Checking for code in URL:", window.location.search);
    if (code) {
      console.log("Auth code found in URL !", );
      const codeVerifierLocal = sessionStorage.getItem('codeVerifier');
      console.log("Code verifier from sessionStorage:", codeVerifierLocal); // DEBUG
      console.log("Code challenge from sessionStorage:", sessionStorage.getItem('codeChallenge')); // DEBUG
      console.log("OAuth state from sessionStorage:", sessionStorage.getItem('oauthState')); // DEBUG
      
      if (!codeVerifierLocal) {
        console.error("ERROR: No codeVerifier found in sessionStorage! This usually means session was cleared after login error.");
        console.error("Redirecting to home page to restart OAuth flow...");
        // Redirect to restart the flow
        window.location.href = '/';
        return;
      }
      
      // Exchange code for token
      (async () => {
        try {
          console.log("Calling token endpoint:", TOKEN_URL);
          const tokenResponse = await axios.post(
            TOKEN_URL,
            new URLSearchParams({
              redirect_uri: REDIRECT_URL+'/home',
              grant_type: 'authorization_code',
              client_id: CLIENT_ID,
              code: code,
              state:state,
              code_verifier: codeVerifierLocal,
            }),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              withCredentials: true,
            }
          );
 
          if (tokenResponse.status === 200) {
           const { access_token, refresh_token, expires_in } = tokenResponse.data;
            sessionStorage.setItem('expiresIn', expires_in);
            await setTokenInCookieAndCallUserCurrent(access_token, refresh_token, expires_in);  
            console.log('Token retrieved successfully!');
            //setDataLoaded(true);
          } else {
            console.error('Failed to retrieve token, status:', tokenResponse.status);
          }
        } catch (error) {
          console.error('Error during token retrieval:', error);
        }
      })();
    } else {
      console.warn("No auth code found in URL on page load.");
    }
  }
 
  const setTokenInCookieAndCallUserCurrent = async (accessToken, refreshToken, expiresIn) => {
    if (accessToken !== null && accessToken !== "") {
      cookies.set(cookieNameToken, accessToken, { path: '/', sameSite: 'strict', secure: window.location.protocol === 'https:' });
      console.log('access token from api response ! ')
    }

      // Set SameSite and Secure flags for cookies
    // Get VPN status from sessionStorage (set in Home.js)
    const isVpnConnected = sessionStorage.getItem('vpnConnected') === 'true';

    UserService.getuserDetails()
      .then((response) => {
        var _user_object = login.setCurrentUserObject(response.data, expiresIn);
        let checkAccountStatus = response.data.accountStatus;

        if (isVpnConnected) {
          // Internal user: onboarded, just set cookies and proceed
          _user_object = encodeURI(JSON.stringify(_user_object));
            cookies.set(cookieNameCurrentUser, _user_object, { path: '/', sameSite: 'strict', secure: window.location.protocol === 'https:' });
            cookies.set(cookieNameUser, response.data.email, { path: '/', sameSite: 'strict', secure: window.location.protocol === 'https:' });
          setUserCookieAvailable(true);
          return;
        }

        // External users only: activation and deleted logic
        if (checkAccountStatus === 'ResetPW' || checkAccountStatus === 'SignedUp') {
          UserService.activateUserAccount().then((res) => {
            console.log("User account activated successfully.");
            if (res.status === 200) {
              _user_object.accountStatus = "Activated";
            }
          })
          .catch(error => {
            console.log(error.status);
          });
        } else if (checkAccountStatus === 'Deleted') {
          setRedirectURL(REDIRECT_URL);
        }

        _user_object = encodeURI(JSON.stringify(_user_object));
          cookies.set(cookieNameCurrentUser, _user_object, { path: '/', sameSite: 'strict', secure: window.location.protocol === 'https:' });
          cookies.set(cookieNameUser, response.data.email, { path: '/', sameSite: 'strict', secure: window.location.protocol === 'https:' });
        setUserCookieAvailable(true);
      })
      .catch(error => {
        // Internal user: not onboarded, redirect to onboarding
        if (
          error.response &&
          error.response.data &&
          error.response.data.code === 'APIM-1000' &&
          isVpnConnected
        ) {
          toast.error(error.response.data.message || "User is not onboarded");
          navigate('/xcorpjoinus');
          return;
        }
        // External users or other errors
        console.log(error.status);
      });
};
 
 
 
 
  // Render login form directly as a native HTML form
  return (
    <div style={{display : 'none'}}>
    {userCookieAvailable === false
     ?<></>
     :(window.location.href = redirectURL)
     }
    </div>
       );
};
 
export default TokenPage;